import { call, put, takeLatest } from 'redux-saga/effects';
import type { SagaIterator } from '@redux-saga/types';
import { getCateringAccess } from '../../services/cateringAccessApi';
import { NO_CATERING_ACCESS, type CateringAccess } from '../../services/cateringAccessPermissions';
import { CACC } from './cateringAccessTypes';
import { loadCateringAccessDone } from './cateringAccessActions';

/** A failed read counts as no access (same as Kiosk Media). */
function* loadAccessWorker(): SagaIterator {
  try {
    const access: CateringAccess = yield call(getCateringAccess);
    yield put(loadCateringAccessDone(access));
  } catch {
    yield put(loadCateringAccessDone(NO_CATERING_ACCESS));
  }
}

export function* cateringAccessSaga(): SagaIterator {
  yield takeLatest(CACC.LOAD_REQUEST, loadAccessWorker);
}
